import React, { FC, memo, Fragment } from 'react'

import { useCurrentSlideIndex } from '../../hooks/carousel'
import { ArrowContainerNext, ArrowRightIcon } from './tips-section-styles'

interface Props {
    numberOfSlides: number
}

const CarouselButtonNext: FC<Props> = ({ numberOfSlides }) => {
    const _currentSlideIndex = useCurrentSlideIndex()

    return _currentSlideIndex !== numberOfSlides - 1 ? (
        <ArrowContainerNext>
            <ArrowRightIcon />
        </ArrowContainerNext>
    ) : (
        <Fragment />
    )
}

export default memo(CarouselButtonNext)
